<template>
  <footer class="py-4 text-center border-t border-gray-200 bg-gray-50">
    <p class="text-xs text-gray-500">
      ©信息学院&百知科技
    </p>
  </footer>
</template>

<script setup>
// 页脚组件，显示版权信息
</script>